import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tabs, Button } from 'antd'
import { Chart, LineAdvance } from 'bizcharts';
import { req_single_cms_learnmap_ucan_alsresult, req_single_cms_learnmap_ucan_alsresult_details, req_single_ucan_token_get } from '../../api'
import { ORG_CODE } from '../../utils/contrains'

const { TabPane } = Tabs
class CoursemapStudentUcanAlsResult extends Component {
    // 初始化作業 ///////////////////////////////////////////////
    state = {
        items: [],
        deviceWidth: 0,
        defaultKey: null,
        loading: false,
        tabledata: [],
        chartdata: [],
        ssourl: null
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this))
        this.resize()
        this.api_init_items()
        this.ucan_sso_process()
    }

    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }
    // 遠端數據處理 //////////////////////////////////////////////

    api_init_items = async () => {
        const { userCode, token } = this.props.user

        this.setState({ loading: true, items: [] })
        const result = await req_single_cms_learnmap_ucan_alsresult(userCode, token)

        if (result.total > 0) {
            //console.log('alsresultresult', result.data);
            const items = result.data;
            const { finished_date, catalogEnName } = items[0]
            const defaultKey = finished_date + catalogEnName 
            this.setState({ items, defaultKey })
            this.tab_change(defaultKey)
        } else {
            this.setState({ loading: false })
        }
    }

    // 介面互動處理 //////////////////////////////////////////////

    tab_change = async (defaultKey) => {

        const key = defaultKey.substr(0, 10)
        const  catalog = defaultKey.substr(10)
        this.setState({ tabledata: [], chartdata: [] })
        const { userCode, token } = this.props.user
        const chart = await req_single_cms_learnmap_ucan_alsresult_details(userCode, catalog, key, token)
        if (chart.total > 0) {
            //console.log('chart', chart.data);
            const tabledata = chart.data
            const chartdata = []
            tabledata.forEach((d, idx) => {
                const name = d.layer2_id
                chartdata.push({ label: name, tag: '測驗結果', value: d.averageScore, })
                chartdata.push({ label: name, tag: '基本水準', value: 3, })
            })
            this.setState({ tabledata, chartdata })
        }
        this.setState({ loading: false })
    }

    ucan_sso_process = async () => {
        const originalUrl = "https://ucan.moe.edu.tw/diagnosis/diagnosis_2.aspx"
        const { userCode } = this.props.user
        const key = ORG_CODE + userCode.replace(/\s+/g, '').toUpperCase()
        const token = await req_single_ucan_token_get(ORG_CODE, key)
        const ssourl = token === 'NA' ? originalUrl : 'https://ucan.moe.edu.tw/bin/index.php?Plugin=o_hdu&Action=ohduschoolssologin&username=' + key + '&school=' + ORG_CODE + '&token=' + token
        this.setState({ ssourl })
    }


    /////////////////////////////////////////////////////////////    
    render() {
        const { loading, items, defaultKey, chartdata, tabledata, deviceWidth, ssourl } = this.state
        // 沒數據
        const originalUrl = ssourl
        const notest = (<div className="alert alert-danger">
            <a href={originalUrl} target="_blank" className="btn btn-mdanger" rel="noreferrer"> <Button type="primary" shape="round" size="small"> 按我 <i className="fas fa-mouse-pointer" style={{ marginLeft: '4px' }}></i></Button> 測測你的專業能力 (註：今日測驗/明日解析)</a>
        </div>)

        // 有數據
        const cols = {
            sales: {
                tickInterval: 0.5,
                max: 5,
                min: 0
            }
        };
        const tabPanes = items.length > 0 ? items.map((d, idx) => <TabPane tab={d.catalogTwName + '-' + d.finished_date} key={d.finished_date+d.catalogEnName}></TabPane>) : ''
        const descriptionhasdata = (<>
            <div>
                <div className="panel-heading">
                    <h4>分數說明如下：</h4>
                </div>
                <div className="panel-body">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th className="col-md-3 text-center" style={{ backgroundColor: 'DarkSlateBlue', color: 'white' }}>分數級距</th>
                                <th className="col-md-9 text-center" style={{ backgroundColor: 'DarkSlateBlue', color: 'white' }}>相關說明</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">
                                    <span>1-2</span>
                                </td>
                                <td>
                                    <span>這項能力還需要特別加強，才能勝任這項工作。</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-center">
                                    <span>2-3</span>
                                </td>
                                <td>
                                    <span>這項能力已經有些基礎，有潛力勝任相關工作。</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-center">
                                    <span>3-4</span>
                                </td>
                                <td >
                                    <span>這項能力程度不錯喔。建議就繼續加強深化，就可以完全勝任這項工作。</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-center">
                                    <span>4以上</span>
                                </td>
                                <td>
                                    <span>這項能力是你可以發揮的優勢，建議你未來再工作要充分展現喔!</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>)
        const tr_ = tabledata.length > 0 ? tabledata.map((row, idx) => <>
            <tr key={idx}>
                <td className="text-center">
                    <span>{row.pathway_name}</span>
                </td>
                <td className="text-center">
                    <span>{row.layer2_id}</span>
                </td>
                <td>
                    <span>{row.layer2_name}</span>
                </td>
                <td className="text-center">
                    <span>{row.averageScore}</span>
                </td>
                <td className="text-center">
                    <span>{row.pr_score_a}</span>
                </td>
            </tr>

        </>) : ''

        return (
            <>
                {loading ? (<div className='text-center'>
                    <p />
                    <button className="btn " type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                        Loading...
                    </button>
                </div>) : (<>
                    {items.length > 0 ? (<>
                        <a className="btn btn-primary" href={originalUrl} target="_blank" rel="noreferrer" >前往UCAN平台測驗 <i className="fas fa-arrow-circle-right"></i> </a>
                        <Tabs defaultActiveKey={defaultKey} onChange={this.tab_change}>
                            {tabPanes}
                        </Tabs>
                        <div className="row" >
                            {deviceWidth > 700 ? (<div className="col-sm col-md-6" >
                                <table className="table table-bordered" >
                                    <thead>
                                        <th className="text-center col-2" style={{ textwrap: 'none', color: 'white', backgroundColor: 'DarkSlateBlue' }}>就業途徑</th>
                                        <th className="text-center col-2" style={{ textwrap: 'none', color: 'white', backgroundColor: 'DarkSlateBlue' }}>職能代碼</th>
                                        <th className="text-center col-6" style={{ textwrap: 'none', color: 'white', backgroundColor: 'DarkSlateBlue' }}>職能項目</th>
                                        <th className="text-center col-1" style={{ textwrap: 'none', color: 'white', backgroundColor: 'DarkSlateBlue' }}>診斷分數</th>
                                        <th className="text-center col-1" style={{ textwrap: 'none', color: 'white', backgroundColor: 'DarkSlateBlue' }}>全國PR值</th>
                                    </thead>
                                    <tbody>
                                        {tr_}
                                    </tbody>
                                </table>
                            </div>) : ''}
                            <div className="col-sm col-md-6" >
                                <Chart padding={[10, 20, 50, 40]} autoFit height={300} data={chartdata} scale={cols} >
                                    <LineAdvance
                                        shape="smooth"
                                        point
                                        area
                                        position="label*value"
                                        color="tag"
                                    />
                                </Chart>
                                {descriptionhasdata}
                            </div>
                        </div>
                    </>) : (<>
                        {notest}
                    </>)}
                </>)}
            </>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentUcanAlsResult)